import { useMemo } from 'react';
import { useLocation } from 'react-router';
import type BoltMetaArgs from 'types/BoltMetaArgs';
import type { CapiNews } from 'types/capi/news';

import PageLoadErrorBoundary from '~/components/PageLoadErrorBoundary';
import useViewEvent from '~/hooks/useViewEvent';
import { getCanonicalUrl } from '~/utils/canonicalUrl';
import seo from '~/utils/seo';

import getArticleFeedViewProperties from '../articleFeedViewProperties';
import NewsFeedView from './NewsFeedView';

export default function NewsFeedRoute() {
  const { search } = useLocation();

  useViewEvent({
    viewProperties: useMemo(
      () => getArticleFeedViewProperties(search),
      [search]
    ),
    viewType: 'article_feed'
  });

  return <NewsFeedView />;
}

export const handle = {
  i18n: ['plp']
};

export function ErrorBoundary() {
  return <PageLoadErrorBoundary pageType="news" />;
}

type LoaderData = {
  pageData: CapiNews;
};

export const meta = (args: BoltMetaArgs<LoaderData>) => {
  const { data } = args;

  if (!data) return [];

  const canonicalUrl = getCanonicalUrl(args, data.pageData.canonical_url);

  return seo.formatForMeta(canonicalUrl, data.pageData.seo);
};

export { loader } from './loader.server';
